import React from 'react';

const SectionIsApplicationAllowed = ({
  isApplicationAllowed,
  setIsApplicationAllowed
}) => {
  return (
    <section id="is_application_allowed">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            プロジェクトの募集状況
          </p>
        </div>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="isApplicationAllowed"
              defaultChecked={isApplicationAllowed}
              onChange={e => {
                setIsApplicationAllowed(e.target.checked);
              }}
            />
            <label
              className="custom-control-label"
              htmlFor="isApplicationAllowed"
            >
              クラファンを募集する
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionIsApplicationAllowed;
